import ContractType from './ContractType'

class PortugalContractType extends ContractType {
  static urlRoot() {
    return '/contracts/portugal/contract_types'
  }
}

export default PortugalContractType
